// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-installation/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springInstallationEN: PageEntry = {
  id: "post.federinstallation",
  locale: "en",
  slug: "spring-installation",
  seo: {
    title: "Glossary: Spring installation explained simply | Dietz GmbH",
    description: "Spring installation refers to the process by which springs are installed into a specific mechanical system. This step is crucial in order for the spring to perform optimally in its",
  },
  type: "post",
  h1: "Glossary: Spring installation explained simply",
  intro: "Spring installation refers to the process by which springs are installed into a specific mechanical system. This step is crucial in order for the spring to perform optimally in its intended function. Spring installation requires precise alignment, fixing and, if necessary, the use of assembly techniques. Care must be taken during installation to ensure that the spring is not overloaded and that its position and alignment meet the design requirements. Proper spring installation will help maximise the performance and life of the spring in a system.",
  blocks: [

  ],
};
